export const repriceVat=(amount:number,from:string,to:string)=>Math.round(amount*(from==='standard_21'?1/1.21:1)*(to==='standard_21'?1.21:1)*100)/100;
// Preserve the original cent amount when toggling a profile back and forth.
export function createVatRepricer() {
 const previous=new Map<string,number>();
 return (amount:number,from:string,to:string)=>{
  if(from===to)return amount;
  const key=JSON.stringify([amount,from,to]);
  const converted=previous.get(key)??repriceVat(amount,from,to);
  previous.set(JSON.stringify([converted,to,from]),amount);
  return converted;
 };
}
